var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Card', {
    staticClass: "card-item",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "padding": 0
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeCard
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close",
      "size": "28"
    }
  })], 1), _c('div', {
    staticClass: "contetn"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px",
      "margin": "28px 0 20px 0"
    },
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.selectSemiItem
    },
    model: {
      value: _vm.semiItemId,
      callback: function ($$v) {
        _vm.semiItemId = $$v;
      },
      expression: "semiItemId"
    }
  }, _vm._l(_vm.semiItemList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.material.model) + "-" + _vm._s(item.factory.name))]);
  }), 1), _vm.semiItem.solidContent ? _c('div', {
    staticClass: "solidContent-wrap"
  }, [_c('div', {
    staticClass: "solidContent-item"
  }, [_c('div', [_vm._v("固含量：")]), _c('div', [_vm._v(_vm._s(_vm.semiItem.solidContent))])]), _c('div', {
    staticClass: "solidContent-item"
  }, [_c('div', [_vm._v("固含价格：")]), _c('div', [_vm._v(_vm._s(_vm.semiItem.unitCostPerSoidContent.toFixed(3)))])])]) : _vm._e(), _c('div', {
    staticClass: "material-table"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.materialTableLoading,
      "columns": _vm.materialTableColumns,
      "data": _vm.materialCostDetail
    }
  })], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }